import { combineReducers } from 'redux';
import type NotificationEntities from '../../../contracts/NotificationEntities';
import { type AsyncState } from '../../../store/types';
import { type NotificationsLoadState, type SoftpullConsentState } from './types';
import * as types from './types';
import initialState from './intialState';

type Action = { type: string; payload?: any };

const defaultAction: Action = { type: '' };

const notificationsReducer = (
  state: NotificationEntities | null = initialState.entities,
  action: Action = defaultAction
) => {
  switch (action.type) {
    case types.FETCH_NOTIFICATIONS_SUCCESS:
      return action.payload;
    case types.UPDATE_TCPA_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        content: {
          ...state?.content,
          general: {
            ...state?.content?.general,
            tcpa: {
              ...state?.content?.general?.tcpa,
              isOptedIn: action.payload
            }
          }
        }
      };
    case types.UPDATE_EMAIL_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        content: {
          ...state?.content,
          email: {
            emailAlerts: action.payload.emailOriginalState.isSubscribedToAlerts,
            emailEvents: action.payload.emailOriginalState.isSubscribedToEvents,
            emailOffers: action.payload.emailOriginalState.isSubscribedToOffers,
            emailPromotions: action.payload.emailOriginalState.isSubscribedToPromotions,
            emailGlobal: action.payload.emailOriginalState.isSubscribedGlobal
          }
        }
      };
    case types.UPDATE_EMAIL_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        content: {
          ...state?.content,
          email: {
            emailAlerts: action.payload.isSubscribedToAlerts,
            emailEvents: action.payload.isSubscribedToEvents,
            emailOffers: action.payload.isSubscribedToOffers,
            emailPromotions: action.payload.isSubscribedToPromotions,
            emailGlobal: action.payload.isSubscribedGlobal
          }
        }
      };
    default:
      return state;
  }
};

const fetchNotificationsReducer = (
  state: NotificationsLoadState = initialState.notifications,
  action: Action = defaultAction
) => {
  switch (action.type) {
    case types.FETCH_NOTIFICATIONS_BEGIN:
      return {
        ...initialState.notifications,
        hasFetched: false,
        isLoading: true
      };
    case types.FETCH_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        hasFetched: false,
        error: action.payload
      };
    case types.FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        hasFetched: true,
        isLoading: false
      };
    default:
      return state;
  }
};

const softpullConsentReducer = (
  state: SoftpullConsentState = initialState.softpullConsent,
  action: Action = defaultAction
) => {
  switch (action.type) {
    case types.FETCH_SOFTPULL_CONSENT_BEGIN:
      return {
        ...initialState.softpullConsent,
        hasFetched: false,
        isLoading: true
      };
    case types.FETCH_SOFTPULL_CONSENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        hasFetched: false,
        error: action.payload
      };
    case types.FETCH_SOFTPULL_CONSENT_SUCCESS:
      return {
        ...state,
        isOptedIn: action.payload,
        hasFetched: true,
        isLoading: false
      };
    case types.UPDATE_CREDIT_MONITORING_CONSENT_BEGIN:
      return {
        ...initialState.softpullConsent,
        isLoading: true
      };
    case types.UPDATE_CREDIT_MONITORING_CONSENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.UPDATE_CREDIT_MONITORING_CONSENT_SUCCESS:
      return {
        ...state,
        isOptedIn: action.payload,
        isLoading: false
      };
    default:
      return state;
  }
};

const updateEmailNotificationsReducer = (
  state: AsyncState = initialState.updateEmailNotifications,
  action: Action = defaultAction
) => {
  switch (action.type) {
    case types.UPDATE_EMAIL_NOTIFICATIONS_BEGIN:
      return {
        ...initialState.updateEmailNotifications,
        isLoading: true
      };
    case types.UPDATE_EMAIL_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    case types.UPDATE_EMAIL_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        isLoading: false
      };
    default:
      return state;
  }
};

const updateTCPANotificationsReducer = (
  state: AsyncState = initialState.updateTCPANotifications,
  action: Action = defaultAction
) => {
  switch (action.type) {
    case types.UPDATE_TCPA_NOTIFICATIONS_BEGIN:
      return {
        ...initialState.updateTCPANotifications,
        isLoading: true
      };
    case types.UPDATE_TCPA_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.UPDATE_TCPA_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        isLoading: false
      };
    default:
      return state;
  }
};

const reducer = combineReducers({
  entities: notificationsReducer,
  notifications: fetchNotificationsReducer,
  softpullConsent: softpullConsentReducer,
  updateEmailNotifications: updateEmailNotificationsReducer,
  updateTCPANotifications: updateTCPANotificationsReducer
});

export default reducer;
